const PLAYER_ID_KEY = 'bluebob_player_id'

/**
 * Get or create a persistent anonymous player ID.
 * Stored in localStorage as a UUID.
 */
export function getPlayerId(): string | null {
  return localStorage.getItem(PLAYER_ID_KEY)
}

/** Store the player ID in localStorage. */
export function setPlayerId(id: string): void {
  localStorage.setItem(PLAYER_ID_KEY, id)
}

/** Check if a player ID exists. */
export function hasPlayerId(): boolean {
  return !!localStorage.getItem(PLAYER_ID_KEY)
}

/** Clear stored player identity. */
export function clearPlayerId(): void {
  localStorage.removeItem(PLAYER_ID_KEY)
}
